export default __webpack_public_path__ + "static/media/securitu-privacy-2.a9536e48.png";